import axios, {removeCancel} from './axiosWrapper';
import  buyCabinet from './buyCabinet/interface'

export const query = params => axios({
  url: '/query',
  method: 'get',
  params
});

export const mock = params => axios({
  url: '/mock',
  method: 'get',
  params
});

export const upload = data => axios({
  url: '/upload',
  method: 'post',
  data
});

/** ***正式接口，暂时模拟**** */

/**
 * 获取全局统一配置
 * @return {axios}
 */
export const getGlobalConfig = () => axios({
  url: '/api/console/getGlobalConfig',
  method: 'get',
  data: {}
});

/**
 * 获取设备列表
 * @param params
 */
export // 获取控制台权限
const getLimit = params => axios({
  url: '/api/consumer/getConsolePermission',
  method: 'get',
  params
});

export // 获取过滤字段列表
const getFiltersList = params => axios({
  url: '/api/resource/listFilterFields',
  method: 'get',
  params
});

export // 获取机柜列表
const getListInstances = params => axios({
  url: '/api/resource/listCabinets',
  method: 'get',
  params
});

export // 获取机柜列表
const getDevicesList = params => axios({
  url: '/api/resource/listDevices',
  method: 'get',
  params
});

/** ********************设备相关开始********************* */
/*
获取设备列表
 */
export const getEquipmentList = params => axios({
  url: '/api/resource/listDevices',
  method: 'get',
  params
});

/*
获取设备详情
 */
export const getEquipmentInfoBySn = params => axios({
  url: '/api/resource/getDeviceInfo',
  method: 'get',
  params
});

/** ********************设备相关开始********************* */

export // 获取机柜详情
const getCabinetInfo = params => axios({
  url: 'api/resource/getCabinetInfo',
  method: 'get',
  params
});

export const getComputerRoom = params => axios({
  url: 'api/resource/listIdcs',
  method: 'get',
  params
});
export const getListRooms = params => axios({
  url: 'api/resource/listRooms',
  method: 'get',
  params
});
export const getCabinetDetail = params => axios({
  url: 'listInfo',
  method: 'get',
  params
});
export const getRegions = params => axios({
  // url: 'getRegions',
  url: '/api/resource/listIdcs',
  method: 'get',
  params
});

// IP地址列表
export const getNetworksList = params => axios({
  url: '/api/resource/listIps',
  method: 'get',
  params
});

// 带宽列表
export const getBandWidthList = params => axios({
  url: '/api/resource/listBandwidths',
  method: 'get',
  params
});
// 查询带宽详情
export const getBandWidthDetail = params => axios({
  url: '/api/resource/getBandwidthInfo',
  method: 'get',
  params
});

// 查询客户信息
export const getUserInfo = params => axios({
  url: '/api/consumer/getUcInfo',
  method: 'get',
  params
});


export const getBaseInfoAndSubUsers = params => axios({
  url: '/api/consumer/getBaseInfoAndSubUsers',
  method: 'get',
  params
});

/** ************************ 专线相关 **************************************** */
// 专线列表
export const describeResourceDirectConnects = params => axios({
  url: '/api/resource/listDirectConnects',
  method: 'get',
  params,
  timeout: 40000
});

/** ************************ 其他资源相关 **************************************** */
 export const describeResourceOtherResources = params => axios({
   url: '/api/resource/listOtherResources',
   method: 'get',
   params,
   timeout: 40000
 });

/** ************************ 工单相关 **************************************** */
// 查询合同列表
export const getContracts = params => axios({
  url: '/api/consumer/listContracts',
  method: 'get',
  params
});

// 查询工单类型
export const getTicketType = params => axios({
  url: '/api/ticket/listTicketTypes',
  method: 'get',
  params
});

// 查询工单模板
export const getTicketTemplates = params => axios({
  url: '/api/ticket/listTicketTemplates',
  method: 'get',
  params
});

// 提交工单
export const submitContracts = data => axios({
  url: '/api/ticket/submitTicket',
  method: 'post',
  data,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 100000
});

// 工单提交附件
export const uploadFile = data => axios({
  url: '/api/ticket/importToOssByName',
  method: 'post',
  data
});

// 查询工单列表
export const getWorkList = params => axios({
  url: '/api/ticket/list',
  method: 'get',
  params
});

// 查询工单列表
export const getWorksheetList = params => axios({
  url: '/api/ticket/list',
  method: 'get',
  params
});

// 查询工单详情
export const getWorksheetDetail = params => axios({
  url: '/api/ticket/baseInfo',
  method: 'get',
  params
});

// 撤销工单
export const cancelWorksheet = data => axios({
  url: '/api/ticket/cancelTicket',
  method: 'post',
  data
});

// 核验方案
export const planWorksheet = data => axios({
  url: '/api/ticket/confirmPlan',
  method: 'post',
  data
});

// 核验交付
export const planedWorksheet = data => axios({
  url: '/api/ticket/confirmDeliver',
  method: 'post',
  data
});

// 确认关单
export const closeWorksheet = data => axios({
  url: '/api/ticket/closeTicket',
  method: 'post',
  data
});

// 获取工单提交字段
export const getAllSubmitFields = params => axios({
  url: '/api/ticket/getSubmitFields',
  method: 'get',
  params
});

// 工单过滤接口 /api/ticket/getStatus
export const getWorksheetMap = params => axios({
  url: '/api/ticket/getStatus',
  method: 'get',
  params
});
// 获取自定义客户信息
export const getCustomInfo = params => axios({
  url: '/api/consumer/getCustomInfo',
  method: 'get',
  params
});
// 设置自定义客户信息
export const setCustomInfo = data => axios({
  url: '/api/consumer/setCustomInfo',
  method: 'post',
  data
});
// 获取机房资源概览
export const getIdcOverview = params => axios({
  url: '/api/resource/getIdcOverview',
  method: 'get',
  params
});

// 获取客户信息
export const getConsumerInfoByName = params => axios({
  url: '/api/consumer/getConsumerInfo',
  method: 'get',
  params
});

/** ********************************************************************************************* */

/** ************ 带宽流量 by shen************** */

// 带宽流量列表
export const listBandwidthTraffics = params => axios({
  url: '/api/monitor/listBandwidthTraffics',
  method: 'get',
  params,
  timeout: 40000
});

// 带宽流量详情-资源信息
export const getBandwidthInfo = params => axios({
  url: '/api/monitor/getBandwidthInfo',
  method: 'get',
  params,
  timeout: 40000
});

// 带宽流量详情-监控信息
export const getBandwidthTrafficInfo = params => axios({
  url: '/api/monitor/getBandwidthTrafficInfo',
  method: 'get',
  params,
  timeout: 40000,
  cancelName: 'getBandwidthTrafficInfoCancel'
});

// 机柜动环信息（时间范围）
export const getCabinetCurrentInfo = params => axios({
  url: '/api/monitor/getCabinetCurrentInfoByTimeRange',
  method: 'get',
  params // {idcNo, cabinetNo, startTime, endTime}
});

// 机柜动环信息（时间区间）
export const getCabinetCurrentInfoByShortcut = params => axios({
  url: '/api/monitor/getCabinetCurrentInfoByInterval',
  method: 'get',
  params // {idcNo, cabinetNo, interval: '15h'}
});

// 查看带宽流量权限
export const getMenuPermission = params => axios({
  url: '/api/consumer/getMenuPermission',
  method: 'get',
  params
});

// 控制台菜单权限（左侧菜单 1 表示有权限，0 表示无权限）
export const getConsoleMenuPermission = params => axios({
  url: '/api/consumer/getConsoleMenuPermission',
  method: 'get',
  params
});
export const getIdcInspectionList = params => axios({
  url: '/api/inspection/getIdcInspectionList',
  method: 'get',
  params
});
export const getIdcInspectionDetail = params => axios({
  url: '/api/inspection/getIdcInspectionDetail',
  method: 'get',
  params
});
export const getDeviceInspectionList = params => axios({
  url: '/api/inspection/getDeviceInspectionList',
  method: 'get',
  params
});

/** ************ end ************** */

/** *****************************************roomEntry******************************************** */

// 获得工单提交字段
export const getSubmitFields = params => axios({
  url: '/api/ticket/getSubmitFields',
  method: 'get',
  params
});

// 提交工单
export const submitTicket = data => axios({
  url: '/api/ticket/submitTicket',
  method: 'post',
  headers: {
    'Content-Type': 'application/json'
  },
  data,
  timeout: 100000
});

// 获得模板相关信息
export const getListTicketTypes = params => axios({
  url: '/api/ticket/listTicketTypes',
  method: 'get',
  params
});

/** **************************************roomEntryEnd******************************************* */

/** **************************************alarmRulesStart******************************************* */
// 获取报警规则
export const getAlarmRulesData = params => axios({
  url: '/api/alarm/listAlarms',
  method: 'get',
  params
});
// 获取报警过滤字段列表
export const getAlarmFiltersList = params => axios({
  url: '/api/alarm/listFilterFields',
  method: 'get',
  params
});
// 获取报警规则详情
export const getRulesInfo = params => axios({
  url: '/api/alarm/getAlarmInfo',
  method: 'get',
  params
});
// 获取报警规则联系人
export const getListAlarmContactPersons = params => axios({
  url: '/api/alarm/listAlarmContactPersons',
  method: 'get',
  params
});
// 获取报警规则联系人
export const getListContactPersons = params => axios({
  url: '/api/alarm/listContactPersons',
  method: 'get',
  params
});

// 报警规则联系组
export const getListAlarmContactGroups = params => axios({
  url: '/api/alarm/listAlarmContactGroups',
  method: 'get',
  params
});
// 报警规则联系组
export const getListContactGroups = params => axios({
  url: '/api/alarm/listContactGroups',
  method: 'get',
  params
});
// 报警规则联系组(未选择)
export const getAlarmContactGroups = params => axios({
  url: '/api/alarm/getAlarmContactGroups',
  method: 'get',
  params
});

// 获取报警规则联系人(未选择)
export const getAlarmContactPersons = params => axios({
  url: '/api/alarm/getAlarmContactPersons',
  method: 'get',
  params
});
// 新增报警规则
export const createAlarm = data => axios({
  url: '/api/alarm/createAlarm',
  method: 'post',
  data,
  headers: {
    'Content-Type': 'application/json'
  },
});
// 修改报警规则
export const updateAlarm = data => axios({
  url: '/api/alarm/updateAlarm',
  method: 'post',
  data,
  headers: {
    'Content-Type': 'application/json'
  },
});
// 启用报警规则
export const enableAlarm = data => axios({
  url: '/api/alarm/enableAlarm',
  method: 'post',
  data
}); // 禁用报警规则
export const disableAlarm = data => axios({
  url: '/api/alarm/disableAlarm',
  method: 'post',
  data
}); // 删除报警规则
export const deleteAlarm = data => axios({
  url: '/api/alarm/deleteAlarm',
  method: 'post',
  data
});
// 检验规则名称是否重复
export const getAlarmInfoByName = params => axios({
  url: '/api/alarm/getAlarmInfoByName',
  method: 'get',
  params
});
/** **************************************alarmRulesEnd******************************************* */

/** ************ 报警历史 by shen************** */

// 获取报警历史列表
export const getAlarmHistoryList = params => axios({
  url: '/api/alarm/listAlarmHistory',
  method: 'get',
  params,
  timeout: 40000
});

// 查询报警历史通知对象
export const getAlarmHistoryNotice = params => axios({
  url: '/api/alarm/getAlarmHistoryNoticeObj',
  method: 'get',
  params,
  timeout: 40000
});


// 获取报警规则列表
export const listAlarms = params => axios({
  url: '/api/alarm/listAlarms',
  method: 'get',
  params
});

// 获取草稿
export const getDraftInfo = params => axios({
  url: '/api/ticket/getDraftInfo',
  method: 'get',
  params
});

// 删除草稿
export const deleteDraft = data => axios({
  url: '/api/ticket/deleteDraft',
  method: 'post',
  data
});
// 保存草稿
export const saveDraft = data => axios({
  url: '/api/ticket/saveDraft',
  method: 'post',
  data,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 保存草稿
export const saveDraftNoTips = (data, nowarn = true) => axios({
  url: '/api/ticket/saveDraft',
  method: 'post',
  data,
  headers: nowarn ? {
      'no-global-config-warn': 1,
      'Content-Type': 'application/json'
  } : {
    'Content-Type': 'application/json',
  }
});

// 获取全量机房
export const listAllIdcs = params => axios({
  url: '/api/console/listAllIdcs',
  method: 'get',
  params
});

// 提交工单获取服务目录机柜类型
export const listAllProducts = params => axios({
  url: '/api/console/listAllProducts',
  method: 'get',
  params
});
/** ******************************交付资源!!********************************* */
/**
 * 设备开通中交付资源套餐列表
 * @param params
 */
export const getListPackages = params => axios({
  url: '/api/resource/listPackages',
  methods: 'get',
  params
});

export const getPackageConfig = params => axios({
  url: '/api/resource/packageConfig',
  methods: 'get',
  params
});
/** ******************************交付资源!!********************************* */

/** ******************************账单!!********************************* */
/**
 * 账单过滤字段
 * @param params
 */
export const getlistFilterFields = params => axios({
  url: '/api/bill/listFilterFields',
  methods: 'get',
  params
});
export const getResourceBillInfo = params => axios({
  url: '/api/bill/getResourceBillInfo',
  methods: 'get',
  params
});
/** ******************************交付资源!!********************************* */
/** ************ 报警历史 by shen end************** */
// ES查询大带宽90天内已导入的端口列表
export const listBigBandwidthPorts = params => axios({
  url: '/api/monitor/listBigBandwidthPorts',
  method: 'get',
  params
});

/**
 * 重构的首页相关请求
 * author: wangyongbo26
 * date: 2026-02-11
 *
 */

// 获取顶部资源统计数据
export const getWelcomeOverview = params => axios({
  url: '/api/resource/getStats',
  method: 'get',
  params
});
// 获取机房资源统计数据
export const getIdcStatsData = params => axios({
  url: '/api/resource/getIdcStats',
  method: 'get',
  params
});
// 获取公告列表
export const getListNotices = params => axios({
  url: '/api/notice/listNotices',
  method: 'get',
  params
});
// 获取公告列表2（新增公告接口） @TODO 替换真实接口地址
export const getListNotices2 = params => axios({
  url: '/api/notice/listNotices2',
  method: 'get',
  params
});
// 获取公告详情
export const getNoticeInfo = params => axios({
  url: '/api/notice/getNoticeInfo',
  method: 'get',
  params
});
// 获取封网和割接通知列表
export const getNetworkFreezeCutoverList = params => axios({
  url: '/api/notice/networkFreezeCutover/list',
  method: 'get',
  params
});
// 获取封网和割接通知详情�
export const getNetworkFreezeCutoverInfo = params => axios({
  url: '/api/notice/networkFreezeCutover/info',
  method: 'get',
  params
});
// 获取运维监控概览数据
export const getMonitorData = params => axios({
  url: '/api/monitor/getOverview',
  method: 'get',
  params
});

/**
 * 获取概览页模块布局信息
 * 接口：GET /api/console/layout/get?pageKey=home
 * 入参 pageKey 为页面唯一标识，例如 home、resource_list。若未传入则默认 'home'。
 * 兼容历史调用方式：调用方传入的 userId 等其它字段会被忽略，保持函数签名向后兼容。
 *
 * @param {Object} [params] - 参数对象，可包含 pageKey 字段；缺省时使用 'home'
 * @returns {Promise<{errno:number, errmsg:string, data:{pageKey:string, layout:{left:string[], right:string[]}}}>}
 */
export const getOverviewLayout = (params = {}) => {
  // 兜底：参数缺失 / 非对象 / pageKey 为空时，默认请求首页布局
  const safeParams = (params && typeof params === 'object') ? params : {};
  const pageKey = (safeParams.pageKey && String(safeParams.pageKey).trim()) || 'home';
  return axios({
    url: '/api/console/layout/get',
    method: 'get',
    params: { pageKey }
  });
};

/**
 * 保存概览页模块布局信息
 * 接口：POST /api/console/layout/save
 * 入参：
 *   - pageKey: 页面唯一标识，必填；调用方未传时默认 'home'
 *   - layout : 布局内容，对象或合法 JSON 字符串，必填；为空时兜底为 { left: [], right: [] }
 * 兼容历史调用方式：调用方传入的 userId 等其它字段会被忽略。
 *
 * @param {Object} [data] - { pageKey?: string, layout: object|string }
 * @returns {Promise<{errno:number, errmsg:string}>}
 */
export const saveOverviewLayout = (data = {}) => {
  const safeData = (data && typeof data === 'object') ? data : {};
  const pageKey = (safeData.pageKey && String(safeData.pageKey).trim()) || 'home';
  // layout 支持对象或合法 JSON 字符串，按后端协议直接透传；空值兜底
  let { layout } = safeData;
  if (layout == null) {
    layout = { left: [], right: [] };
  }
  return axios({
    url: '/api/console/layout/save',
    method: 'post',
    data: { pageKey, layout },
    headers: {
      'Content-Type': 'application/json'
    }
  });
};
// 获取工单概览
export const getTicketData = params => axios({
  url: '/api/ticket/getOverview',
  method: 'get',
  params
});


export default {
  query,
  mock,
  upload,
  removeCancel,
  getEquipmentList,
  getEquipmentInfoBySn,
  getRegions,
  getListInstances,
  getCabinetDetail,
  getNetworksList,
  getBandWidthList,
  getWorkList,
  getCabinetInfo,
  getDevicesList,
  getComputerRoom,
  getListRooms,
  getBandWidthDetail,
  getLimit,
  getFiltersList,
  getContracts,
  submitContracts,
  getWorksheetList,
  getWorksheetDetail,
  getUserInfo,
  cancelWorksheet,
  closeWorksheet,
  planWorksheet,
  planedWorksheet,
  getTicketType,
  getTicketTemplates,
  uploadFile,
  getWorksheetMap,
  getCustomInfo,
  setCustomInfo,
  getIdcOverview,
  getConsumerInfoByName,
  getAllSubmitFields,
  getSubmitFields,
  getListTicketTypes,
  submitTicket,
  listBandwidthTraffics,
  getBandwidthInfo,
  getBandwidthTrafficInfo,
  getMenuPermission,
  getConsoleMenuPermission,
  getIdcInspectionList,
  getIdcInspectionDetail,
  getDeviceInspectionList,
  getCabinetCurrentInfo,
  getCabinetCurrentInfoByShortcut,

  // 告警规则
  getAlarmRulesData,
  getAlarmHistoryList,
  getAlarmHistoryNotice,
  getAlarmFiltersList,
  listAlarms,
  getRulesInfo,
  getListAlarmContactGroups,
  getListAlarmContactPersons,
  getListContactGroups,
  getListContactPersons,
  getAlarmContactGroups,
  getAlarmContactPersons,
  createAlarm,
  updateAlarm,
  enableAlarm,
  disableAlarm,
  deleteAlarm,
  getAlarmInfoByName,
  saveDraft,
  getDraftInfo,
  deleteDraft,
  saveDraftNoTips,
  listAllIdcs,
  listAllProducts,
  // 设备开通中交付资源套餐列表
  getListPackages,
  getPackageConfig,
  buyCabinet,
  getlistFilterFields,
  getResourceBillInfo,
  getBaseInfoAndSubUsers,
  listBigBandwidthPorts,
  describeResourceDirectConnects,
  describeResourceOtherResources,
  getWelcomeOverview,
  getIdcStatsData,
  getListNotices,
  getListNotices2, // @TODO 替换真实接口名
  getNoticeInfo,
  getNetworkFreezeCutoverList,
  getNetworkFreezeCutoverInfo,
  getMonitorData,
  getTicketData,
  getOverviewLayout,
  saveOverviewLayout,
};



// WEBPACK FOOTER //
// ./src/axiosHandler/interface.js